import { TrackingEventName } from '@/models/analytics/eventTypes';
import {
  trackVerificationCompletedSpec,
  trackVerificationFailedSpec,
  trackVerificationFeedbackSubmittedSpec,
  trackVerificationStartedSpec,
  trackVerificationSuggestedFixAppliedSpec,
  type VerificationCompleted,
  type VerificationFailed,
  type VerificationFeedbackSubmitted,
  type VerificationStarted,
  type VerificationSuggestedFixApplied,
} from '@snowtype/snowplow';
import type { SnowplowEventMap } from '../trackSnowplowEvent';

export const verificationEvents: SnowplowEventMap = {
  [TrackingEventName.VerificationStarted]: (props) =>
    trackVerificationStartedSpec(props as VerificationStarted),
  [TrackingEventName.VerificationCompleted]: (props) =>
    trackVerificationCompletedSpec(props as VerificationCompleted),
  [TrackingEventName.VerificationFailed]: (props) =>
    trackVerificationFailedSpec(props as VerificationFailed),
  [TrackingEventName.VerificationFeedbackSubmitted]: (props) =>
    trackVerificationFeedbackSubmittedSpec(props as VerificationFeedbackSubmitted),
  [TrackingEventName.VerificationSuggestedFixApplied]: (props) =>
    trackVerificationSuggestedFixAppliedSpec(props as VerificationSuggestedFixApplied),
};
